/**
 * Product page: variant selection, gallery thumbnails, quantity stepper,
 * sticky buy bar, and dispatching the add-to-cart event the cart drawer
 * already listens for (see cart-drawer.js, event "product:add-to-cart").
 */

function init() {
  var variantsDataEl = document.querySelector('[data-product-variants]');
  if (!variantsDataEl) return;

  var variants = JSON.parse(variantsDataEl.textContent);
  var isPremium = window.productPageIsPremium === true;

  var variantIdInput = document.querySelector('[data-variant-id-input]');
  var priceContainer = document.getElementById('product-price-display');
  var mainImage = document.querySelector('[data-product-main-image]');
  var thumbnails = Array.prototype.slice.call(document.querySelectorAll('[data-product-thumbnail]'));
  var optionButtons = Array.prototype.slice.call(document.querySelectorAll('[data-option-value-btn]'));
  var addToCartBtn = document.querySelector('[data-add-to-cart-btn]');
  var addToCartLabel = document.querySelector('[data-add-to-cart-label]');
  var wishlistBtn = document.querySelector('[data-wishlist-add]');
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var productPageEl = document.querySelector('.product-page');
  var dailyPriceTemplate = productPageEl ? productPageEl.getAttribute('data-daily-price-template') : '';
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAddBtn = document.querySelector('[data-sticky-add-btn]');
  var qtyDecrease = document.querySelector('[data-qty-decrease-page]');
  var qtyIncrease = document.querySelector('[data-qty-increase-page]');
  var qtyValue = document.querySelector('[data-qty-value-page]');
  var quantityInput = document.querySelector('[data-quantity-input]');
  var productForm = addToCartBtn ? addToCartBtn.closest('form') : null;

  // Start from whichever option values are already marked selected in the
  // rendered HTML (the server-rendered default variant), one entry per
  // option index.
  var optionCount = 0;
  optionButtons.forEach(function (btn) {
    var index = parseInt(btn.getAttribute('data-option-index'), 10);
    if (index + 1 > optionCount) optionCount = index + 1;
  });

  var selectedOptions = new Array(optionCount);
  optionButtons.forEach(function (btn) {
    if (btn.classList.contains('is-selected')) {
      var index = parseInt(btn.getAttribute('data-option-index'), 10);
      selectedOptions[index] = btn.getAttribute('data-option-value');
    }
  });

  function findMatchingVariant() {
    return variants.filter(function (variant) {
      return variant.options.every(function (value, i) {
        return value === selectedOptions[i];
      });
    })[0];
  }

  function renderPriceHtml(variant) {
    if (!priceContainer) return;

    if (isPremium) {
      var compareBlock = variant.comparePriceHtml
        ? '<span class="price-display__compare">' + variant.comparePriceHtml + '</span>'
        : '';
      priceContainer.innerHTML =
        compareBlock +
        '<span class="price-display__amount price-display__amount--small">' + variant.priceHtml + '</span>' +
        '<span class="price-display__daily">' + dailyPriceTemplate.replace('__PRICE__', variant.dailyPriceHtml) + '</span>';
    } else {
      var compareBlockEconomy = variant.comparePriceHtml
        ? '<span class="price-display__compare">' + variant.comparePriceHtml + '</span>'
        : '';
      priceContainer.innerHTML =
        '<span class="price-display__amount price-display__amount--large">' + variant.priceHtml + '</span>' +
        compareBlockEconomy;
    }
  }

  function swapMainImage(url) {
    if (!mainImage || !url || mainImage.src === url) return;

    mainImage.classList.add('is-fading');
    window.setTimeout(function () {
      mainImage.src = url;
      mainImage.classList.remove('is-fading');
    }, 150);
  }

  function updateUiForVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;
    renderPriceHtml(variant);

    if (stickyPrice) stickyPrice.textContent = variant.priceHtml;

    if (wishlistBtn) wishlistBtn.setAttribute('data-product-price', variant.priceHtml.replace(/[^0-9.,]/g, ''));

    if (variant.featuredImageUrl) {
      swapMainImage(variant.featuredImageUrl);
      var matchingThumb = thumbnails.filter(function (thumb) {
        return thumb.getAttribute('data-media-id') === variant.featuredMediaId;
      })[0];
      if (matchingThumb) setActiveThumbnail(matchingThumb);
    }

    var available = variant.available;
    [addToCartBtn, stickyAddBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
    });
    if (addToCartLabel) {
      addToCartLabel.textContent = available
        ? addToCartLabel.getAttribute('data-label-add')
        : addToCartLabel.getAttribute('data-label-sold-out');
    }
  }

  function setActiveThumbnail(thumb) {
    thumbnails.forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');

      optionButtons
        .filter(function (b) {
          return parseInt(b.getAttribute('data-option-index'), 10) === index;
        })
        .forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });

      selectedOptions[index] = value;
      updateUiForVariant(findMatchingVariant());
    });
  });

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      swapMainImage(thumb.getAttribute('data-image-url'));
      setActiveThumbnail(thumb);
    });
  });

  function updateQuantity(newQty) {
    if (newQty < 1) newQty = 1;
    if (qtyValue) qtyValue.textContent = newQty;
    if (quantityInput) quantityInput.value = newQty;
  }

  if (qtyIncrease) {
    qtyIncrease.addEventListener('click', function () {
      updateQuantity(parseInt(quantityInput.value, 10) + 1);
    });
  }

  if (qtyDecrease) {
    qtyDecrease.addEventListener('click', function () {
      updateQuantity(parseInt(quantityInput.value, 10) - 1);
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      document.dispatchEvent(new CustomEvent('product:add-to-cart', {
        detail: {
          variantId: variantIdInput ? variantIdInput.value : null,
          quantity: quantityInput ? parseInt(quantityInput.value, 10) : 1
        }
      }));
    });
  }

  // The sticky bar delegates to the real submit button instead of
  // duplicating the add-to-cart logic — one source of truth for what
  // happens when someone actually buys.
  if (stickyAddBtn && addToCartBtn) {
    stickyAddBtn.addEventListener('click', function () {
      addToCartBtn.click();
    });
  }

  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      var product = {
        id: wishlistBtn.getAttribute('data-product-id'),
        title: wishlistBtn.getAttribute('data-product-title'),
        price: wishlistBtn.getAttribute('data-product-price'),
        image: wishlistBtn.getAttribute('data-product-image')
      };

      document.dispatchEvent(new CustomEvent('product:toggle-wishlist', {
        detail: product
      }));
    });
  }

  // Sticky buy bar: shows up only once the real add-to-cart button has
  // scrolled out of view, so there is always exactly one obvious place to
  // tap "buy" on screen, never zero and never two competing for attention.
  if (stickyBar && addToCartBtn) {
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      stickyBar.classList.toggle('is-visible', entry && !entry.isIntersecting);
    }, { threshold: 0 });

    observer.observe(addToCartBtn);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
